import { render } from "./questions.vue?vue&type=template&id=db1755a8"
import script from "./questions.vue?vue&type=script&lang=js"
export * from "./questions.vue?vue&type=script&lang=js"
script.render = render

export default script